import { useIsMobile } from "./useIsMobile";

export default useIsMobile;
